// @flow-strict

const ToastDefaultOptions = {
  position: 'top-right',
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

export const ToastSuccessOptions = (props) => ({
  ...ToastDefaultOptions,
  autoClose: 10000,
  ...props
});

export const ToastErrorOptions = (props) => ({
  ...ToastDefaultOptions,
  autoClose: 10000,
  ...props
});